import { render, staticRenderFns } from "./selectedBox1.vue?vue&type=template&id=1b261a53&"
import script from "./selectedBox1.vue?vue&type=script&lang=js&"
export * from "./selectedBox1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports